export default "__VITE_ASSET__Bohq5Fia__"